import { Type } from './action-types';

export const hidePostTask = () => ({
  type: Type.POST_TASK_HIDE,
});

export const clearPostTaskState = () => ({ type: Type.POST_TASK_CLEAR });
